import './Pagination.css';

const DEFAULT_PAGE_SIZES = [10, 20, 50, 100];

export function Pagination({
  currentPage,
  totalCount,
  pageSize,
  rowCount,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = DEFAULT_PAGE_SIZES,
}) {
  const inferredTotal = totalCount > 0 ? totalCount : Math.max(0, currentPage - 1) * pageSize + (rowCount || 0);
  const totalPages = Math.max(1, Math.ceil(inferredTotal / pageSize));
  const from = (rowCount ?? 0) === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const to = (rowCount ?? 0) === 0 ? 0 : from + (rowCount - 1);
  return (
    <div className="ui-pagination">
      <div className="ui-pagination-info">
        {from}-{to} / <strong>{inferredTotal}</strong> kayıt
        {rowCount > 0 && <span className="ui-pagination-page">Sayfa {currentPage} / {totalPages}</span>}
      </div>
      <div className="ui-pagination-controls">
        <button
          type="button"
          className="ui-pagination-btn"
          disabled={currentPage === 1}
          onClick={() => onPageChange?.(Math.max(1, currentPage - 1))}
          aria-label="Önceki sayfa"
        >
          ‹
        </button>
        <button
          type="button"
          className="ui-pagination-btn"
          disabled={currentPage >= totalPages}
          onClick={() => onPageChange?.(Math.min(totalPages, currentPage + 1))}
          aria-label="Sonraki sayfa"
        >
          ›
        </button>
        <select
          className="ui-pagination-size"
          value={pageSize}
          onChange={(e) => onPageSizeChange?.(Number(e.target.value))}
          aria-label="Sayfa boyutu"
        >
          {pageSizeOptions.map((s) => <option key={s} value={s}>{s} / sayfa</option>)}
        </select>
      </div>
    </div>
  );
}
